/**
 * Die Archivübersicht (ADR 0025): alles mit archivierendem Status.
 *
 * Archivierte Geräte fallen aus allen aktiven Listen (ADR 0005). Beim Test in
 * der Halle war deshalb ein archivierter Winkelschleifer nirgends zu finden.
 * Hier stehen sie, das zuletzt gebuchte zuerst -- was eben versehentlich
 * archiviert wurde, steht oben.
 *
 * Aus der lokalen Kopie, also auch offline.
 */

import type { Artikel, StatusArt, Zustand } from "@thw/contracts";
import type { Bestand } from "./bestand.js";

export interface ArchivZeile {
  artikel: Artikel;
  zustand: Zustand;
}

export interface ArchivFilter {
  status: StatusArt;
  anzahl: number;
}

/** Alle archivierten Geräte, das zuletzt gebuchte zuerst. */
export function archivierte(bestand: Bestand): ArchivZeile[] {
  const zeilen: ArchivZeile[] = [];
  for (const [id, zustand] of bestand.zustaende) {
    if (!zustand.archiviert) continue;
    const artikel = bestand.artikel.get(id);
    if (artikel !== undefined) zeilen.push({ artikel, zustand });
  }
  return zeilen.sort(
    (a, b) =>
      (b.zustand.letzte_buchung_am ?? "").localeCompare(a.zustand.letzte_buchung_am ?? "") ||
      a.artikel.bezeichnung.localeCompare(b.artikel.bezeichnung, "de"),
  );
}

/**
 * Ein Filter je archivierendem Status, in der Reihenfolge der Stammdaten. Ein
 * stillgelegter erscheint nur, solange ihn noch jemand trägt.
 */
export function archivFilter(bestand: Bestand, zeilen: readonly ArchivZeile[]): ArchivFilter[] {
  const anzahl = new Map<string, number>();
  for (const z of zeilen) anzahl.set(z.zustand.status, (anzahl.get(z.zustand.status) ?? 0) + 1);
  return bestand.statusArten
    .filter((s) => s.archiviert && (s.aktiv || anzahl.has(s.schluessel)))
    .map((status) => ({ status, anzahl: anzahl.get(status.schluessel) ?? 0 }));
}
